import {
  Gender,
  KeyPartyType,
  ProfileTabsTypes,
  SearchType,
} from "../../../shared/constants/common.constant";
import { formatDateAsPerServer, getFullName } from "../../../utils";
import { CreateProfileType } from "../types/createProfile.type";
import {
  AddressTypes,
  CreateNewKeyPartyValues,
  NewKeyPartyPayload,
  Profile,
  ProfileCategory,
  ProfileTypes,
} from "../types/profile.type";

export const isIndividualOrSoleTrader = (profileType: string): boolean => {
  return (
    profileType === CreateProfileType.individual ||
    profileType === CreateProfileType.soleTrader
  );
};

const getKeyPartyType = (
  values: CreateNewKeyPartyValues,
  subTabType: string
) => {
  if (subTabType === ProfileTabsTypes.keyParties) {
    return values.keyPartyType;
  } else if (subTabType === ProfileTabsTypes.ubos) {
    return KeyPartyType.ubo;
  }
};

export const payloadBuilderAddKeyparties = (
  values: CreateNewKeyPartyValues,
  subTabType: string
) => {
  const fullName = getFullName(values);

  let keyPartyPayload: NewKeyPartyPayload = {
    ...(values?.firstName && values?.lastName
      ? {
          firstName: values.firstName,
          middleName: values.middleName,
          lastName: values.lastName,
        }
      : {
          name: fullName as string,
        }),
    entityType: values.profileType as ProfileTypes,
    keyPartyType: getKeyPartyType(values, subTabType),
    countryCode: values.country,
    address: {
      ...values.address,
      type: AddressTypes.registered,
      description: null,
      countryCode: values.country ?? null,
    },
    ...(values.keyPartyType === KeyPartyType.shareholder && {
      percentageOfShares: values.sharePercentage ?? null,
    }),
    ...(values.keyPartyType === KeyPartyType.other && {
      description: values.description ?? null,
    }),
  };

  if (values.profileType === SearchType.Individual) {
    keyPartyPayload = {
      ...keyPartyPayload,
      gender: values.gender === Gender.notSpecified ? null : values.gender,
      dateOfBirth:
        (values?.dateOfBirth && formatDateAsPerServer(values.dateOfBirth)) ??
        null,
      ...(values.keyPartyType === KeyPartyType.director && {
        role: values.role,
      }),
    };
  } else if (values.profileType === SearchType.Business) {
    keyPartyPayload = {
      ...keyPartyPayload,
      organisationNumber: values.organisationNumber,
      activityCode: values.activityCode,
    };
  }
  return keyPartyPayload;
};

export const isValidTurnOver = (
  currencyCode: string | null,
  amount: number | null
) => {
  if (!currencyCode && !amount) {
    return true;
  } else if (currencyCode && amount) {
    return true;
  } else {
    return false;
  }
};

export const checkMonitoringCondition = (
  profileData: Profile,
  monitoringCountryCode: string[]
) => {
  const transformCode = (code: string): string => {
    const firstThreeChars = code.slice(0, 3).toUpperCase();

    if (firstThreeChars.startsWith("PLC")) {
      return "WW";
    } else if (firstThreeChars.startsWith("UK")) {
      return "GB";
    } else {
      return code.slice(0, 2);
    }
  };

  const slicedSafeNumber =
    profileData?.safeNumber && transformCode(profileData.safeNumber);
  const slicedCompanyId =
    profileData?.companyId && transformCode(profileData.companyId);

  if (
    (slicedSafeNumber && monitoringCountryCode.includes(slicedSafeNumber)) ||
    (slicedCompanyId && monitoringCountryCode.includes(slicedCompanyId)) ||
    slicedSafeNumber === "WW" ||
    slicedCompanyId === "WW"
  ) {
    return true;
  } else {
    return false;
  }
};

export const isIndividualOrBusiness = (profileType: string): string => {
  if (
    profileType === ProfileTypes.individual ||
    profileType === ProfileTypes.soleTrader
  ) {
    return ProfileCategory.individual;
  } else {
    return ProfileCategory.business;
  }
};
